export default {
  categories: {
    trends: 'Home',
    home: 'Home',
    popular: 'Most viewed',
    all: 'All',
    trends_recent_all: 'Latest videos',
  },
  notFound: {
    title: 'Sorry, the page you requested was not found!',
    go_back: 'Back to the homepage',
  },
  buttons: {
    search: 'Search',
    integrate: 'Share',
    see_more: 'See more',
    see_less: 'See less',
    accept: 'Accept',
    copy: 'Copy',
    like:'Like',
    download:'Download'
  },
  labels: {
    footer:
      'By continuing your navigation on our site, you accept the use of cookies intended to improve the functionalities of the site.',
    description: 'Description',
    powered_by: 'Powered by',
    no_video: 'No videos',
    loading: 'Loading ...',
    search: 'Search...',
    integrations: 'Share',
    integrations_options: 'Integrations options',
    start_video_auto: 'Start playback automatically',
    default_color: 'Default color',
    start_at: 'Start at',
    share_social: 'Share on social networks',
    embedTitle: 'embed code',
    permalink: 'Permalink',
  },
  titles: {
    video_duration: 'Duration of the video',
    suggestions: 'Suggestions',
  },
  menu: {
    home: 'Home',
    trends: 'Trends',
    popular: 'Popular',
    all: 'All',
    allVideos: 'All videos',
  },
    footer:{
        contact:"Contact",
        legal:"Legal",
        license:"License"
    }
};



// WEBPACK FOOTER //
// ./src/i18n/en_US.js